import React, { useCallback, useEffect, useRef, useState } from "react";
import Modal from "../../components/Modals/Modal";
import SecondaryButton from "../../components/Buttons/SecondaryButton";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

function ImageCropModal({ setShowImageCrop, showImageCrop, image, setImage, handleCancel }) {
  const [crop, setCrop] = useState({
    unit: 'px',
    x: 130,
    y: 50,
    width: 200,
    height: 200
  });
  const [cropImage, setCropImage] = useState(null);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [newImage, setNewImage] = useState({});


  const onLoad = useCallback((img) => {
    setCropImage(img)
  }, []);

  const handleSubmit = () => {
    let newProfilePic = Object.assign({}, newImage);
    newProfilePic.url = newImage.url;
    newProfilePic.file = new File([newImage.file], image.file.name, {
      type: newImage.file.type,
    });
    setImage(newProfilePic);
    setShowImageCrop(false);
  };

  useEffect(() => {
    if (!completedCrop || !cropImage) {
      return;
    }

    const image = cropImage;
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    const pixelRatio = window.devicePixelRatio;
    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";
  
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    newImage.url = canvas.toDataURL("image/jpeg", 1);

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if(blob){
          newImage.url = window.URL.createObjectURL(blob);
          newImage.file = blob;
          setNewImage(newImage);
          resolve(blob);
        }
       
      }, "image/jpeg");
    });
  }, [completedCrop]);

  return (
    <Modal title={"Crop Image"} show={showImageCrop} hide={handleCancel}>
      <div className="text-center m-8">
        <ReactCrop
          src={image?.url}
          crop={crop}
          onImageLoaded={onLoad}
          onChange={(c) => setCrop(c)}
          onComplete={(c) => setCompletedCrop(c)}
        />
      </div>
      <div className="grid grid-cols-2 gap-x-2 mt-6">
        <SecondaryButton onClick={handleCancel} text="Cancel" />
        <PrimaryButton onClick={handleSubmit} text="Save" />
      </div>
    </Modal>
  );
}

export default ImageCropModal;
